export default "__VITE_ASSET__GE6ZZSJa__"